import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';

import { StatusBadge, type StatusTone } from '@/components/ui/status-badge';

// The accident severities of `models.AccidentSeverity`, with the labels the
// activity log already uses.
const SEVERITY: Record<string, { tone: StatusTone; label: MessageDescriptor }> = {
  minor: { tone: 'neutral', label: msg({ id: 'activities.severity.minor', message: 'Minor' }) },
  moderate: { tone: 'warning', label: msg({ id: 'activities.severity.moderate', message: 'Moderate' }) },
  serious: { tone: 'danger', label: msg({ id: 'activities.severity.serious', message: 'Serious' }) },
  critical: { tone: 'danger', label: msg({ id: 'activities.severity.critical', message: 'Critical' }) },
};

/** The severity of an accident notification, or nothing for an unknown value. */
export function AccidentSeverityBadge({ severity }: { severity: string | undefined }) {
  const { i18n } = useLingui();
  const entry = severity ? SEVERITY[severity] : undefined;
  if (!entry) return null;
  return <StatusBadge tone={entry.tone} label={i18n._(entry.label)} />;
}
